import { lazy } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const ReleasesField = lazy(
	() => import(/* webpackChunkName: "async-dev-panel-releases-field" */ './main'),
);

export default ReleasesField;
